// import "../../common/prefixName.js"
import Link from '../../common/prefixName'
import externalApp from '../../data/externalApp'
import "../../css/kefu_icon_panel.css"
import '../../js/content_module/bottom_menu';
import returnButtonHelper from "../../js/content_module/returnButton";
import bannerModuleHelper from "../../js/content_module/banner";
import "./articleRecommendControl.js"

// utils
import adUtil from '../../lib/util/ad';

// config
var apiBaseUrl = Link.prefix.realmName;
var pageConfig = {
	apiConfig : {
		get : {
			url : apiBaseUrl + 'portal/article/get'
		},
		praise : {
			url : apiBaseUrl + 'portal/article/praise'
		},
		cancelPraise : {
			url : apiBaseUrl + 'portal/article/cancelPraise'
		},
		loadCommentList : {
			url : apiBaseUrl + 'portal/article/comment/listByCommentId'
		},
		addComment : {
			url : apiBaseUrl + 'portal/article/comment/add',
			method : 'post'
		}
	},
	articleDetailElement : '#mainControl',
	articleDetailDataColumn : [
		'accessoryList', 'category', 'commentCount', 'content', 'coverImg', 'created', 'id', 'isRecommend', 'isShow',
		'like', 'pv', 'pvSham', 'sort', 'tag', 'title', 'updateTime', 'userId', 'authorImage', 'author', 'isLike'
	],
	articleDetailColumnMapping : {
	    // id : '',
		like : 'praise',
		isLike : 'isFabulous',
		author : 'userName',
		authorImage : 'userImg',
		created : 'createTime',
		categoryName : 'categoryFirstId'
	},
	commentColumnMapping : {
		authorName : 'userName',
		authorImage : 'headerImg',
		authorId : 'userId',
		publishedTime : 'createTime'
	},
	commentDisplayPerPage : 8,
	parentPage : externalApp.newShixun.baseUrl + 'index.html'
};

if (typeof (emojify) !== 'undefined')
{
	emojify.setConfig({
		img_dir : 'https://h5.shixun365.com/shixun-static/emojify.js/dist/images/basic' // not need / ending
	});
}

// Link.verifyLoin();
moment.locale('zh-cn');

app.init(appConfig);

returnButtonHelper.setAction(function(){
	location.href = pageConfig.parentPage;
});

// append banner module, must set a unique ID.
$(bannerModuleHelper.element).attr('id', 'article_detail_banner_1');
$('#articleRecommendContent').before(bannerModuleHelper.element);
bannerModuleHelper.init();
bannerModuleHelper.loadData({
	typeEnum: 'HOME_NEWS_DETAIL'
}, {
	id : getUrlParam('id')
});

var mainControl = initVueItemDetail({
	el : pageConfig.articleDetailElement,
	apiConfig : pageConfig.apiConfig,
	data : {
		commentList : [],
		commentListPage : 1,
		commentListPageCount : 0,
		commentAreaStatus : '',
		commentAreaMessage : '',
		commentContent : '',
		articleId : '',
		userInfo : null,
        checkedLogin : false,
        adMap : {
		    top : null,
		    bottom : null
        },
		learnStartTime : null,
		learnEndTime : null,
	},
	dataColumn : pageConfig.articleDetailDataColumn,
	columnMapping : pageConfig.articleDetailColumnMapping,
	methods : {
		openUrl: function(id, url){
			$.ajax({
				url: Link.prefix.realmName + "/portal/advertis/click",
				data: {
					id: id
				},
				success: function (result) {},
				error: function (result) {
				},
				complete: function() {
					//set Session Key
					setSessionData('ad_sessino_key',id);
					location.href=url;
				}
			});
		},
	    onLike : function (event){
            var target = event.currentTarget;
            var lock = target.dataset.lock || 'off';
            if (lock == 'on')
			{
				addConsoleLog('like action is already locked.');
				return;
			}

            lock = target.dataset.lock = 'on';
            var url = '';
            var method = '';
			if (this.itemData.isLike)
			{
				url		= pageConfig.apiConfig.cancelPraise.url;
				method	= pageConfig.apiConfig.cancelPraise.method || 'get';
			}
			else
			{
				url		= pageConfig.apiConfig.praise.url;
				method	= pageConfig.apiConfig.praise.method || 'get';
			}
			debugger
			var me = this;
			console.log(me.itemData.id)
			$.ajax({
				url : url,
				type : method,
				data : { id :me.itemData.id },
				success : function (result){

          if (result.errorCode == 2)
					{
						  location.href = '../login/login.html';
							return;
					}

					if (result.errorCode)
					{
						addConsoleLog(result.msg);
						app.showMessageBox('点赞失败，请稍后再试。');
						return;
					}

					// udate article data
					me.itemData.isLike	= !me.itemData.isLike;
					me.itemData.like	= me.itemData.isLike ? me.itemData.like + 1 : me.itemData.like - 1;

                    me.$forceUpdate();
                },
				error : function (error){
					if (error.responseJSON.errorCode == 2)
					{
						  location.href = '../login/login.html';
							return;
					}
					app.showMessageBox('点赞失败，请稍后再试。');
				},
				complete : function (){
					lock = target.dataset.lock = 'off';
				}
			});
        },
		loadCommentList : function(page){
			if (page)
			{
				this.commentListPage = page;
			}

			this.commentAreaStatus = 'loading';

			var me = this;
			$.ajax({
				url : pageConfig.apiConfig.loadCommentList.url,
				type : pageConfig.apiConfig.loadCommentList.method || 'get',
				data : {
					articleId : me.articleId,
					page : this.commentListPage,
					limit : pageConfig.commentDisplayPerPage
				},
				success : function (result){

					if (result.errorCode)
					{
						app.showMessageBox(result.msg);
						me.commentAreaStatus = 'error';
						me.commentAreaMessage = result.msg;
						return;
					}

					me.commentAreaStatus = 'ready';
					var data = listDataColumnConvert(result.data.rows, pageConfig.commentColumnMapping);

					me.commentList = me.commentList.concat(data);
					me.commentListPageCount = result.data.totalPage;
				},
				error : function (){
					me.commentAreaStatus = 'error';
					me.commentAreaMessage = '评论数据加载失败';
				}
			});
		},
		loadMoreComment : function ()
		{
			if (this.commentListPageCount && this.commentListPageCount <= this.commentListPage)
			{
				addDebugLog('no more comment. count page: ' + this.commentListPageCount + ' page: ' + this.commentListPage);
				return;
			}

			this.loadCommentList(this.commentListPage + 1);
		},
		submitComment : function (){
			if (!this.commentContent.length)
			{
				$('#commentInputbox').focus();
				return;
			}

			var me = this;
			$.ajax({
				url : pageConfig.apiConfig.addComment.url,
				type : pageConfig.apiConfig.addComment.method,
				data : {
					articleId : me.articleId,
					content : me.commentContent
				},
				success : function (result){
					if (result.errorCode)
					{
						app.showMessageBox(result.msg);
						return;
					}

					// clean old content
					me.commentContent = '';

					// refresh page 1
					app.toast('评论发布成功！');
					me.commentList = [];
					me.loadCommentList(1);
				},
				error : app.config.ajaxErrorHandle
			});
		},
        /* set wechat share. */
        setWechatShare : function (){

            // 检查登录后和加载数据后执行，必要条件：文章数据、已检查登录状态
            var data = this.itemData;
            var userInfo = this.userInfo;
            if (!this.checkedLogin)
            {
                return;
            }

            // var content = data.data.content;
            var desc = DecodeHtml(data.content || '');
            desc = removeHtmlTag(desc);
            desc = removeLineBreak(desc);
            desc = removeSpace(desc);
            if (desc.length > 20)
            {
                desc = desc.substr(0, 20) + '...';
            }

            var imageUrl = $(data.content).find('img').attr('src');
            var introduceCode = userInfo.introduceCode || '';
            var urlParams = {
                incode : introduceCode,
                promotionCode : introduceCode
            };
            var shareUrl = createUrl(location.href, urlParams);
            var wechatShareOptions = {
                title: document.title, // 分享标题
                desc: desc,
                link : shareUrl,
                imgUrl: imageUrl // 分享图标
            };

            app.setWechatShare(wechatShareOptions);
        },
		formatCommentDate : function(timestamp){
			return moment(timestamp).format('YYYY/MM/DD');
		},
		submitBrowsingRecord() {

            this.learnEndTime = new Date().getTime();

            let data = {
                browsingBizId : this.articleId,
                browsingBizType : 5,
                startTime : this.learnStartTime,
                endTime : this.learnEndTime,
            };
			$.ajax({
				url : Link.prefix.realmName + 'portal/v4/browsing/add',
				method : 'post',
				data : data,
				suceess : function() {
					//if (result.errorCode)
					//{
					//	appHelper.showHint(result.msg);
					//	return;
					//}

				}
			});
        },
	},
	onDataLoaded : function (data, controller){

		mainControl.articleId = data.id;
		mainControl.loadCommentList();

		document.title = '师讯-' + data.title;

		var me = mainControl;
		
		submitClientLog();

		me.itemData = data;
        Link.verifyLoin(function(user){

            me.checkedLogin = true;

            if (user)
            {
                me.userInfo = user;

                //wx log

                let code = getUrlParam('promotionCode')
                if (code) {
                    $.ajax({
                        type: 'POST',
                        url: Link.prefix.realmName  + 'base/wx/jssdkconfig/transmitBrow',
                        data: {
                            id: getUrlParam('id'),
                            bizType: 'ARTICLE',
                            promotionCode: code
                        },
                        dataType: 'JSON',
                        success: function(res) {}
                    })
                }
            }

            if (isWechat())
            {
                // set wechat share
                app.loadWechatJSSDKConfig({
                    jsApiList : [
                        'onMenuShareAppMessage', 'onMenuShareTimeline',
                        'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
                        'updateAppMessageShareData', 'updateTimelineShareData'
                    ],
                    onReady : function () {
                        me.setWechatShare();
                    },
                    onError : function (){

                    }
                });
            }
        });

        // if (isWechat())
        // {
        //     wx.ready(function(){
        //         controller.setWechatShare();
        //     });
        // }

		// load
        adUtil.load({
            id : data.id,
            typeEnum : 'HOME_NEWS_DETAIL_TOP'
        }, function (result) {
            if (!result.data)
            {
                return;
            }
            mainControl.adMap.top = result.data[0];
        });

        adUtil.load({
            id : data.id,
            typeEnum : 'HOME_NEWS_DETAIL_BOTTOM'
        }, function (result) {
            if (!result.data)
            {
                return;
            }
            mainControl.adMap.bottom = result.data[0];
        });

		return data;
	},
    onCreated : function () {

        addDebugLog('controller created.');

    },
    onMounted : function (controller) {

	    addDebugLog('controller mounted.');

	    var me = window.mainControl = controller;
		
		// start learn
        controller.learnStartTime = new Date().getTime();
    },
	onUpdated : function (me){

        addDebugLog('controller updated.');

		if (typeof (emojify) !== 'undefined')
		{
			emojify.run(me.$el);
			emojify.run($('.articleContent')[0]);
		}
	}
});

function submitClientLog() {
	let clientLogId = localStorage.getItem('clientLogId');

	let data = {
		pageKey : 'mes-details',
		pageName : document.title,
		pageRoute : location.href,
        client : 'WEB',
        clientVersion : '6.0',
        networkEnv : 'UN_KNOW'
	};
	clientLogId ? data.PId = clientLogId : null;

	$.ajax({
		url : Link.prefix.realmName + '/portal/client/log',
		method : 'post',
		data : data,
		success : function(result) {

			if (result.errorCode)
			{
				console.error(result.msg);
				return;
			}

			localStorage.setItem('clientLogId', result.data);
		},
		error: function(error) {
			console.error(error);
		}
	});
}

window.onbeforeunload = function closeWindow(e)
{
	mainControl.submitBrowsingRecord();
	
	/*
    if (!READYTOPROCESS)
    {
        //message to be returned to the popup box.
        var message = '你确定要关闭吗？',
            e = e || window.event;
        if (e)
            e.returnValue = message; // IE
        return message; // Safari
    }*/
};



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/article/detail.js
 **/